// extracted by mini-css-extract-plugin
module.exports = {"selectedImageLink":"SingleInspirationModal_selectedImageLink__2imEl","imageWrapper":"SingleInspirationModal_imageWrapper__2k-J1"};